<template>
  <div>
    <div class="collapse navbar-collapse-left show" id="slidepanel">
      <div class="fix-orderdetails h-100">
        <button class="navbar-toggler navbar-toggler-right close-btn border-0 orderpanel-close-btn" type="button"
          data-toggle="collapse" data-target="#slidepanel" aria-controls="slidepanel" aria-expanded="true"
          aria-label="Toggle navigation">
          <span><i class="fas fa-times"></i></span>
        </button>
        <div class="order-details h-100 d-flex justify-content-between flex-column">
          <div class="order-top">
            <div class="d-flex justify-content-between align-items-center border-bottom">
              <h4 v-if="cart.length > '0'">
                {{ $t("Your Order") }}
                <span class="total-items">({{ cart.reduce((a, c) => a + c.quantity, 0) }}
                  {{
                    cart.reduce((a, c) => a + c.quantity, 0) > 1
                      ? $t("Items")
                      : $t("Item")
                  }})</span>
              </h4>
              <p v-if="cart.length > 0" class="mb-0 pe-auto mr-3 mouse-hover" @click="clearCartModal">
                Clear Cart
              </p>
            </div>

            <div class="order-items-main orderitems-nw" v-if="cart.length > '0'">
              <div class="order-item d-flex align-content-center justify-content-between mt-3 pb-2"
                style="border-bottom: 1px solid #f5f5f5;" v-for="(item, index) in cart" :key="index">
                <div class="item-heading">
                  <!-- <span class="remove_item" @click="deleteProduct(index)">&times;</span> -->
                  <!-- <div class="veg"><span></span></div> -->
                  <div class="veg" v-if="item.item_type == '0'">
                    <span></span>
                  </div>
                  <div class="non-veg" v-if="item.item_type == '1'">
                    <img class="non-veg-img" src="@/assets/images/non_veg.png" />
                  </div>
                  <p class="mb-0">
                    {{ item.name }}
                    {{ item?.selected_type?.length > 0 ? ":" : "" }}
                  </p>
                  <div class="selected_type">
                    <div class="selected-main" v-for="(itemOption, key) in item.selected_type" :key="key">
                      <p class="selected-radio">{{ itemOption }}</p>
                    </div>
                  </div>
                </div>
                <div class="number d-flex align-items-center">
                  <span class="minus d-flex justify-content-center align-items-center"
                    @click="minusItem(item, index)">-</span>
                  <input type="text" :value="item.quantity" readonly />
                  <span class="plus d-flex justify-content-center align-items-center"
                    @click="plusItem(item, index)">+</span>
                </div>
                <!-- <div class="cart-price-div">
                <span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{getTotalItemPrice(item).toFixed(2)}}
              </div> -->
              </div>
            </div>
            <div v-else class="order-items-main cart-emt-cls">
              <img src="@/assets/images/empty cart.png" />
              <p class="empty-cart">
                {{ $t("Your cart is empty Add items to get started") }}
              </p>
            </div>
          </div>
          <div class="checkout-btn full-btn checkout-desktop-button" v-if="
            cart.length > '0' &&
            $auth.setting &&
            ($auth.setting.is_system_available == '1' ||
              $auth.setting.is_system_available == 'Yes')
          ">
            <span class="licence-info d-block text-center" v-if="fssaiLicence">FSSAI Licence Number : {{ fssaiLicence
              }}</span>
            <b-button variant="primary" class="nxt-btn" disabled v-if="is_btn_spinner">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("Loading") }}...
            </b-button>

            <a class="cart-button" v-else href="javascript:void(0)" @click="minimunOrderValue()">{{ cart.reduce((a, c)
              => a + c.quantity, 0) }}
              {{
                cart.reduce((a, c) => a + c.quantity, 0) > 1
                  ? $t("Items added")
                  : $t("Item added")
              }}
              <!-- <span v-html="$auth.setting && $auth.setting.currency" class="currency"></span> -->
              <small v-if="manageText && manageText != ''">{{
                manageText
              }}</small>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--Alert Modal start-->
    <AlertModal v-if="isAlert" :DisplayAlertData="AlertData" v-on:modalClose="onModalCloseFun"></AlertModal>
    <!--Alert Modal End-->
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import AlertModal from "../components/AlertModal.vue";
import { CouponTypes } from "../helper/helper.js";

export default {
  components: { AlertModal },
  data() {
    return {
      text: "",
      isAuthenticated: false,
      restaurantData: {},
      isAlert: false,
      AlertData: {},
      is_btn_spinner: false,
      fssaiLicence: "",
    };
  },
  mounted() {
    this.getTotalAmount();
    if (this.$auth.user) {
      this.isAuthenticated = true;
      this.getRestaurantInfo();
    } else {
      this.isAuthenticated = false;
    }
  },
  // watch:{
  //   "cart":function(){
  //     this.manageText
  //   }
  // },
  computed: {
    ...mapGetters("product", ["cart"]),
    manageText() {
      let offer = {
        id: "",
        qty: "",
        item_required: "",
        get_item: "",
      };
      let avoidId = [];
      this.cart.forEach((e) => {
        if (e.offer.length > 0) {
          e.offer.forEach((t) => {
            if (
              t.coupon_type == CouponTypes.BOGO &&
              !avoidId.includes(Number(t.id))
            ) {
              if (offer.id == t.id) {
                offer.qty = Number(offer.qty) + Number(e.quantity);
              } else if (offer.id == "") {
                offer.id = Number(t.id);
                offer.qty = Number(e.quantity);
                offer.item_required = Number(t.item_required);
                offer.get_item = Number(t.get_item);
              }

              let total = Number(offer.item_required) + Number(offer.get_item);
              if (total <= offer.qty) {
                offer.id = "";
                offer.qty = "";
                offer.item_required = "";
                offer.get_item = "";
                avoidId.push(offer.id);
              }
            }
          });
        }
      });

      if (offer.id && offer.id != "") {
        let substract =
          Number(offer.item_required) +
          Number(offer.get_item) -
          Number(offer.qty);

        if (substract > 0) {
          return (
            "Add " +
            substract +
            " more item to avail " +
            Number(offer.get_item) +
            " free."
          );
        }
      }
      return "";
    },
  },

  updated() {
    this.getRestaurantInfo();
  },
  methods: {
    ...mapActions("product", ["addProductToCart", "removeProductFromCart"]),
    ...mapMutations("product", [
      "decrementProductInventary",
      "IncrementItemQuantity",
    ]),
    ...mapActions("restaurant", ["getRestaurantDetails"]),

    clearCartModal() {
      this.$swal({
        title: this.$t("Are you sure you want to clear cart?"),
        type: "warning",
        customClass: {
          confirmButton: "cofirm-btn-new",
          cancelButton: "cancle-btn-new",
          title: "clear-cart-text mt-3 mb-1",
        },
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.commit("product/clearCartItems");
        }
      });
    },
    onModalCloseFun(value) {
      this.isAlert = false;
    },

    getRestaurantInfo() {
      if (this.cart.length) {
        var restaurantId = this.cart[0].restaurant_id;
        this.getRestaurantDetails({
          vendor_id: this.$auth.getVendorId(),
          restaurant_id: restaurantId,
          is_langauge: this.$store.state.lang.locale,
        }).then((data) => {
          if (data.code == 200) {
            this.restaurantData = data.Result;
            this.fssaiLicence = this.restaurantData.fssai_licence;
          }
        });
      }
    },
    //Increament Item
    plusItem(item, index) {
      if (item.itemTotalQuantity > item.quantity) {
        this.$store.commit("product/IncrementItemQuantity", index);
      } else {
        this.$swal("Chowman", "Maximum items reached");
      }
    },

    //Decrement Item
    minusItem(cartProduct, index) {
      if (cartProduct.quantity == "1" || cartProduct.quantity == "0") {
        this.deleteProduct(index);
      } else {
        this.$store.commit("product/decrementProductInventary", index);
      }
    },

    //Remove Item from cart
    deleteProduct: function (index) {
      if (this.cart.length == 1) {
        localStorage.setItem("orderUploadImages", "");
      }
      this.$store.dispatch("product/removeProductFromCart", index);
    },

    //Display Total Amount Of item cart
    getTotalItemPrice(item) {
      return item.price * item.quantity;
    },

    //Display Total Amount Of Cart
    getTotalAmount() {
      let total = 0;
      this.cart.forEach((item) => {
        total += item.price * item.quantity;
      });
      return total;
    },

    minimunOrderValue() {
      this.is_btn_spinner = true;
      if (!this.cart.length) {
        //alert(this.$t("Please add Item in to cart"));
        this.$swal("Chowman", "Please add Item in to cart");
        this.is_btn_spinner = false;
        return false;
      }
      if (
        parseFloat(this.getTotalAmount().toFixed(2)) <=
        parseFloat(this.$auth.setting.min_order_value)
      ) {
        this.AlertData = {
          displayMessage:
            this.$t("Minimum items total must be ") +
            this.$auth.setting.currency +
            this.$auth.setting.min_order_value,
          isSetClass: "cart-modal-cls",
        };
        this.isAlert = true;
        window.$(this.$refs.AlertModal).modal();
        this.is_btn_spinner = false;
      } else {
        var restaurantId = this.cart[0].restaurant_id;
        this.getRestaurantDetails({
          vendor_id: this.$auth.getVendorId(),
          restaurant_id: restaurantId,
          is_langauge: this.$store.state.lang.locale,
        }).then((data) => {
          this.restaurantData = data.Result;
          if (this.$auth.user) {
            this.is_btn_spinner = false;
            this.$router.push({ name: "review-cart" });
          } else {
            this.is_btn_spinner = false;
            this.$router.push({ name: "sign-in" });
          }
        });
      }
    },
  },
};
</script>
